import React, { useCallback, useEffect, useRef } from 'react'
import { useMemo } from 'react'

import { gestisciAgentiColumns } from './columns/_columns'
import { useAuth as UsePermissions } from '../../../../../modules/auth/core/Auth'
import GenericTable, {
  GenericTableHandle
} from '../../../../../components/GenericTable'
import { useAuth } from '../../../../../context/Auth'
import {
  PaginatedResponse,
  PaginationMeta
} from '../../../../../interfaces/PaginatedResponse'
import { list } from '../../../../../lib/fetch/users'
import { User } from '../core/_models'
import { Filters } from '../components/header/UsersListFilter'

type GestisciAgentiTableProps = {
  filters?: Filters
  currentPermissions: any
}

const GestisciAgentiTable = ({
  filters,
  currentPermissions
}: GestisciAgentiTableProps) => {
  const [{ token }] = useAuth()
  const ref = useRef<GenericTableHandle>(null)
  const refetch = useCallback(() => {
    ref.current?.refetch()
  }, [ref])
  const { setCanWrite } = UsePermissions()
  const columns = useMemo(() => gestisciAgentiColumns(refetch), [refetch])

  useEffect(() => {
    setCanWrite(currentPermissions?.can('write', 'users'))
  }, [currentPermissions])

  const fetch = useCallback(
    async (
      paginationMeta: PaginationMeta
    ): Promise<PaginatedResponse<User> | string> => {
      let result
      try {
        result = await list({
          token,
          page: paginationMeta.currentPage,
          limit: paginationMeta.itemsPerPage,
          type: 'frontOffice',
          ...filters
        })
      } catch (error) {
        let message = 'Error'
        if (error instanceof Error) {
          message = error.message
        }
        result = message
      }
      return result
    },
    [filters, token]
  )

  return <GenericTable columns={columns} onFetch={fetch} ref={ref} />
}

export { GestisciAgentiTable }
